import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import qs from 'qs';

import { LockOutlined, ArrowBack } from '@material-ui/icons';

import { Paper, Grid, Typography, Divider } from '@material-ui/core';
import Input from '../../../components/Input';
import Button from '../../../components/Button';
import OTP from '../../../components/OTP';

import { loginStart, loginPassword, loginVerifyCode } from '../store/thunk';
import { handleLogout, setLoginValues, setLoginStep } from '../store/actions';
import { clearProfile } from '../../Profile/store/actions';
import { clearBusinessInfo } from '../../BusinessInfo/store/actions';

import { useStyles } from './styles';

import { emailRegExp } from 'helpers/regex';

import projectPackage from '../../../../package.json';

const logo = require('../../../assets/img/logo_login.svg');

const Login = () => {
  const dispatch = useDispatch();

  const classes = useStyles();

  const history = useHistory();
  const location = useLocation();

  const isResale = !!process.env.REACT_APP_RESALE_ID;
  const resaleId = process.env.REACT_APP_RESALE_ID;
  const resaleName = process.env.REACT_APP_RESALE_NAME;
  const signinButtonColor = process.env.REACT_APP_RESALE_LOGIN_SIGNIN_BUTTON_COLOR;
  const signupButtonColor = process.env.REACT_APP_RESALE_LOGIN_SIGNUP_BUTTON_COLOR;
  const signupButtonText = process.env.REACT_APP_RESALE_LOGIN_SIGNUP_BUTTON_TEXT;

  const [loading, setLoading] = useState(false);

  const {
    loginValues,
    loginSteps,
    loginAttemptToken,
    challengeToken,
    loggedIn,
    establishments
  } = useSelector(state => state.login);

  const [loginValuesErrors, setLoginValuesErrors] = useState({
    email: '',
    password: '',
    code: ''
  });

  const isInvoiceLoginUrl = location.pathname == '/area-cliente';
  const isCreditCardUrl = location.pathname == '/cadastro-cartao';

  const doesUserHaveAnyEstablishment =
    establishments[0]?.establishmentId || establishments[establishments.length - 1]?.establishmentId;

  useEffect(() => {
    const notAuthorized = qs.parse(location.search, { ignoreQueryPrefix: true }).notauthorized;

    if(notAuthorized) {
      dispatch(handleLogout());
      toast.error('Ação não autorizada. Por favor, efetue o login antes de continuar.');
    }

    if(loggedIn && isInvoiceLoginUrl) {
      return history.push('/suas-assinaturas');
    }

    if(loggedIn && isCreditCardUrl) {
      return history.push({
        pathname: '/suas-assinaturas',
        state: {
          data: {
            isFromLogin: true
          }
        }
      });
    }

    if(loggedIn && doesUserHaveAnyEstablishment) {
      return history.push('/visao-geral');
    }
  }, []);

  const handleLogin = values => {
    dispatch(clearProfile());

    setLoginValuesErrors({
      email: '',
      password: '',
      code: ''
    });

    if(loginSteps == 'email_code') {
      if(!values?.code) {
        return setLoginValuesErrors({
          ...loginValuesErrors,
          code: 'O código de autenticação é obrigatório'
        });
      }

      if(values?.code?.length < 6) {
        return setLoginValuesErrors({
          ...loginValuesErrors,
          code: 'O código de autenticação deve ter 6 dígitos'
        });
      }

      setLoading(true);

      return dispatch(loginVerifyCode(challengeToken, values?.code, history))
        .finally(() => setLoading(false));
    }

    if(loginSteps == 'password') {
      if(!values?.password) {
        return setLoginValuesErrors({
          ...loginValuesErrors,
          password: 'A senha é obrigatória'
        });
      }

      setLoading(true);

      return dispatch(loginPassword(loginAttemptToken, values?.password, history))
        .finally(() => setLoading(false));
    }

    if(loginSteps == 'email') {
      if(!values?.email) {
        return setLoginValuesErrors({
          ...loginValuesErrors,
          email: 'O e-mail é obrigatório'
        });
      }

      if(!emailRegExp.test(values?.email)) {
        return setLoginValuesErrors({
          ...loginValuesErrors,
          email: 'O e-mail precisa ser válido'
        });
      }

      setLoading(true);

      return dispatch(loginStart(values?.email, process.env.REACT_APP_RESALE_ID))
        .finally(() => setLoading(false));
    }
  }

  const handleRegistration = () => {
    dispatch(clearProfile());
    dispatch(clearBusinessInfo());

    localStorage.clear();
  }

  return(
    <Grid
      container
      spacing={0}
      alignItems="center"
      justify="center"
      className={classes.container}
    >
      <Grid item md={4} xs={12}>
        <Paper elevation={0} className={classes.paper}>
          <img
            src={isResale ? process.env.REACT_APP_RESALE_LOGIN_LOGO : logo}
            width="100"
            height="auto"
            alt={isResale ? resaleName : 'Jump Park'}
          />
          <Typography paragraph variant="h6" color="primary">
            Bem-vindo ao
            <br />
            <Typography variant="h5" color="primary" className={classes.title}>
              {isResale ? resaleName : 'Jump Park'}
            </Typography>
          </Typography>
          <form
            onSubmit={event => {
              event.preventDefault();
              return handleLogin(loginValues);
            }}
            onKeyDown={event => {
              if(event.key == 'Enter') {
                event.preventDefault();
                return handleLogin(loginValues);
              }
            }}
          >
            {(loginSteps == 'email') && (
              <Input
                name="email"
                type="email"
                label="Email"
                value={loginValues?.email}
                error={!!loginValuesErrors.email}
                helperText={loginValuesErrors.email}
                onChange={event => dispatch(setLoginValues(event.target.name, event.target.value?.trim()))}
              />
            )}
            {(loginSteps == 'password') && (
              <Input
                name="password"
                type="password"
                label="Senha"
                value={loginValues.password}
                error={!!loginValuesErrors.password}
                helperText={loginValuesErrors.password}
                onChange={event => dispatch(setLoginValues(event.target.name, event.target.value))}
              />
            )}
            {(loginSteps == 'email_code') && (
              <>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', marginBottom: 20 }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 50, height: 50, backgroundColor: 'rgb(2, 42, 92, 0.2)', borderRadius: '50%' }}>
                    <LockOutlined
                      style={{ color: '#022A5C' }}
                      fontSize="large"
                    />
                  </div>
                </div>
                <Typography variant="h5">
                  Preencha o código
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Enviamos um código por email
                </Typography>
                <OTP
                  value={loginValues.code}
                  error={!!loginValuesErrors.code}
                  helperText={loginValuesErrors.code}
                  onChange={code => dispatch(setLoginValues('code', code))}
                />
              </>
            )}
            <Button
              fullWidth
              verticalGutter
              type="submit"
              color={isResale ? signinButtonColor : 'secondary'}
              loading={loading}
            >
              Entrar
            </Button>
            {(loginSteps == 'password' || loginSteps == 'email_code') && (
              <Typography
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10 }}
                variant="body1"
                color="textSecondary"
                component={Link}
                onClick={() => {
                  if(loginSteps == 'password') {
                    dispatch(setLoginStep('email'));
                  }

                  if(loginSteps == 'email_code') {
                    dispatch(setLoginStep('password'));
                  }
                }}
              >
                <ArrowBack fontSize='small' />
                Voltar
              </Typography>
            )}
          </form>
          <Divider className={classes.divider} />
          <Link
            to={{
              pathname: resaleId ? `/${resaleId}/cadastro-inicial` : '/cadastro-inicial',
              state: { isRegister: true }
            }}
            style={{ textDecoration: 'none' }}
            onClick={() => handleRegistration()}
          >
            <Button
              fullWidth
              color={isResale ? signupButtonColor : 'success'}
            >
              {signupButtonText || "Iniciar teste grátis de 7 dias"}
            </Button>
          </Link>
        </Paper>
        <Typography className={classes.version}>
          Versão {projectPackage.version}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Login;
